<script setup>
import { onErrorCaptured, watch } from 'vue';
import { RouterView } from 'vue-router';
import ToastHost from './components/ToastHost.vue';
import RouteProgress from './components/RouteProgress.vue';
import { useUiStore } from './stores/ui.js';
import { useAuthStore } from './stores/auth.js';

const ui = useUiStore();
const auth = useAuthStore();

// Discard page/store state belonging to the previous account, including when
// logout or login happened in a different tab. Token rotations keep this page.
watch(() => auth.user?.id, (next, previous) => {
  if (!previous || next === previous) return;
  const nextPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.location.replace(next ? '/' : `/login?next=${encodeURIComponent(nextPath)}`);
}, { flush: 'sync' });

onErrorCaptured((error) => {
  console.error(error);
  ui.toast('Не удалось отобразить часть интерфейса', 'error');
  return false;
});
</script>

<template>
  <RouterView />
  <RouteProgress />
  <ToastHost />
</template>
